module.exports = __webpack_public_path__ + "img/logo-login.14a8418e.jpg";